const puzzle = {
  id: "kxj1dnUb1m0Xfwp6VE2F",
  name: "It's a Marvelous World",
  rebuses: [
    {
      style: {},
      id: "4914597c-0562-44ba-8f94-a7c293f2ecd7",
      solutionInfo: {
        solvedText: "Arizona",
        possibleSolutions: [
          {
            id: "843011a3-bf8a-4d75-9ca1-448dd6f18f43",
            value: "Arizona",
          },
        ],
        type: "text",
      },
      clues: [
        {
          dependsOn: [],
          helperText: "It's a canyon carved by the Colorado river.",
          id: "0d5c60f8-3b00-41e4-9d85-a91869e6edb1",
          clueGroup: 0,
          solutionInfo: {
            solvedText: "Grand Canyon",
            possibleSolutions: [
              {
                id: "de2d9393-25f5-4cb1-8b55-ec8e152022d4",
                value: "Grand Canyon",
              },
              {
                value: "Grand",
                id: "40288e54-3465-4b5f-a89a-4487b8fdd51c",
              },
            ],
            type: "text",
          },
          subtext: "",
          style: {
            width: "calc(33% - 10px)",
          },
          clueValues: [
            {
              style: {
                width: "calc(100% - 10px)",
              },
              id: "1c9e72f2-6108-4c6e-a409-b60ec12bbf3a",
              type: "image",
              subtext: "",
              value: "JuqjVO7d.jpg",
            },
          ],
        },
        {
          clueGroup: 0,
          subtext: "",
          solutionInfo: {
            possibleSolutions: [],
            solvedText: "",
            type: "text",
          },
          clueValues: [
            {
              value: "F1qYueSN.png",
              style: {
                width: "calc(100% - 10px)",
              },
              id: "68d04358-60b9-46f2-9165-a7e336887bc5",
              subtext: "",
              type: "image",
            },
          ],
          id: "70178bc6-826d-419b-bad8-d993f57603f1",
          helperText: "",
          dependsOn: [],
          style: {
            width: "calc(33% - 10px)",
          },
        },
      ],
    },
    {
      id: "72e078c3-59f7-4b50-9c1f-c2fda604ae9c",
      clues: [
        {
          style: {
            width: "calc(25% - 10px)",
          },
          helperText: "What material are these fictional characters made of?",
          subtext: "",
          clueValues: [
            {
              style: {
                width: "calc(100% - 10px)",
              },
              id: "2209da9f-9033-400c-a537-ade7b35347c4",
              subtext: "",
              value: "Pinocchio, Groot, Whomping Willow",
              type: "text",
            },
          ],
          solutionInfo: {
            type: "text",
            possibleSolutions: [
              {
                id: "ec66c123-fc9f-4002-941f-6ace7a9e9a05",
                value: "Wood",
              },
            ],
            solvedText: "Wood",
          },
          dependsOn: [],
          clueGroup: 0,
          id: "e296816b-8cd3-4fc9-b462-f1edca43974c",
        },
        {
          subtext: "",
          solutionInfo: {
            solvedText: "",
            possibleSolutions: [],
            type: "text",
          },
          clueValues: [
            {
              id: "2a63bd65-4df9-45fb-b09d-0dfc5eb537ef",
              type: "text",
              style: {
                width: "calc(100% - 10px)",
              },
              subtext: "",
              value: "+",
            },
          ],
          id: "d295210f-3aad-45f2-9c75-a9d9f1470b6f",
          helperText: "",
          clueGroup: 0,
          style: {
            width: "calc(5% - 10px)",
          },
          dependsOn: [],
        },
        {
          id: "259fb42c-ecf6-4a9c-a0a5-2bc1a5e84522",
          subtext: "",
          clueValues: [
            {
              style: {
                width: "calc(100% - 10px)",
              },
              value: "wRARCUVD.png",
              type: "image",
              subtext: "Johnny Storm, Johnny Blaze, Johnny Allerdyce",
              id: "0df618de-9a09-4555-bbdd-e2f03f172f80",
            },
          ],
          helperText:
            "What superpower do these fictional characters have in common?",
          dependsOn: [],
          style: {
            width: "calc(30% - 10px)",
          },
          clueGroup: 0,
          solutionInfo: {
            type: "text",
            solvedText: "Fire",
            possibleSolutions: [
              {
                id: "94c44e57-08da-4c15-aee6-e9ad2aeb5673",
                value: "Fire",
              },
            ],
          },
        },
        {
          solutionInfo: {
            possibleSolutions: [],
            solvedText: "",
            type: "text",
          },
          style: {
            width: "calc(5% - 10px)",
          },
          clueGroup: 0,
          clueValues: [
            {
              id: "2f1553f3-b930-44cc-b8d1-bb6535f99710",
              type: "text",
              value: "=",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          helperText: "",
          dependsOn: [],
          id: "cc8675b6-6362-4e04-9252-5758a72200fc",
          subtext: "",
        },
        {
          solutionInfo: {
            solvedText: "Ash",
            type: "text",
            possibleSolutions: [
              {
                value: "Ash",
                id: "5b94c36b-30cf-448d-ad94-3f4eab6c972e",
              },
            ],
          },
          style: {
            width: "calc(25% - 10px)",
          },
          id: "96f33e87-618c-4ff7-a72b-a2402a017e07",
          clueValues: [
            {
              type: "text",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
              },
              id: "aa30942a-fb1b-44f5-82b5-16c8f6379a1a",
              value: "___",
            },
          ],
          dependsOn: [],
          clueGroup: 0,
          subtext: "",
          helperText: "",
        },
      ],
      solutionInfo: {
        solvedText: "Ash",
        possibleSolutions: [],
        type: "text",
      },
      style: {},
    },
    {
      id: "93385571-f283-487b-a67e-59858f6a0a49",
      clues: [
        {
          solutionInfo: {
            type: "text",
            possibleSolutions: [
              {
                value: "Jean",
                id: "64cb6449-8fe1-4c68-add1-48d1eebb7fa4",
              },
            ],
            solvedText: "Jean",
          },
          dependsOn: [],
          style: {
            width: "calc(33% - 10px)",
          },
          clueGroup: 0,
          helperText:
            "Convert Roman numerals to Arabic numerals and find which letters are in that position in alphabet.",
          id: "4cff4771-4539-4973-ab98-c5b0abb5268b",
          subtext: "_ _ _ _",
          clueValues: [
            {
              value: "A, B, C...Z",
              id: "210ad522-70f2-4ad4-bdd1-1509ba927076",
              style: {
                width: "calc(100% - 10px)",
              },
              subtext: "",
              type: "text",
            },
            {
              type: "text",
              subtext: "",
              value: "I, II, III...XXVI",
              style: {
                width: "calc(100% - 10px)",
              },
              id: "23eeaf6f-d5b2-4f27-9868-28033db82a1d",
            },
            {
              type: "text",
              id: "d26a29d8-d729-4df1-aa7c-9e3eed10f0e1",
              style: {
                width: "calc(100% - 10px)",
              },
              value: "X   V   I   XIV",
              subtext: "",
            },
          ],
        },
        {
          solutionInfo: {
            solvedText: "Grey",
            possibleSolutions: [
              {
                id: "c9d07871-13a7-4f56-bf4d-0fb603127424",
                value: "Grey",
              },
              {
                id: "56c85d05-89ef-4d9d-8e2b-348c9693b3b1",
                value: "Gray",
              },
            ],
            type: "text",
          },
          helperText: "Which color has this hexadecimal value?",
          clueValues: [
            {
              subtext: "#7a7a7a",
              style: {
                width: "calc(100% - 10px)",
              },
              value: "ARWCDyfd.png",
              id: "66286a34-9879-4f51-ab3b-d6fff406c270",
              type: "image",
            },
          ],
          subtext: "",
          style: {
            width: "calc(33% - 10px)",
          },
          id: "16a13c52-d254-4a7b-936a-cdead6e659c2",
          dependsOn: [],
          clueGroup: 0,
        },
      ],
      style: {},
      solutionInfo: {
        type: "text",
        possibleSolutions: [],
        solvedText: "Jean Grey",
      },
    },
    {
      solutionInfo: {
        type: "text",
        possibleSolutions: [
          {
            id: "e32dd736-6513-4568-ab35-2e963db28157",
            value: "Phoenix",
          },
        ],
        solvedText: "Phoenix",
      },
      style: {},
      clues: [
        {
          subtext: "",
          helperText: "It's the capital of Arizona.",
          style: {
            width: "calc(33% - 10px)",
          },
          id: "c04dc489-7799-448c-9eaa-3f9fb99decec",
          clueValues: [
            {
              type: "text",
              value: "Arizona",
              style: {
                width: "calc(100% - 10px)",
              },
              subtext: "",
              id: "f17bc1c0-c9a3-4fab-8320-ea21bc935319",
            },
          ],
          solutionInfo: {
            possibleSolutions: [],
            type: "text",
            solvedText: "",
          },
          clueGroup: 1,
          dependsOn: [],
        },
        {
          clueGroup: 2,
          subtext: "",
          id: "795b3158-5dd5-4b43-b01c-1d3f7898f3bd",
          style: {
            width: "calc(33% - 10px)",
          },
          solutionInfo: {
            solvedText: "",
            type: "text",
            possibleSolutions: [],
          },
          helperText: "It turns into ash once it dies and then it's reborn.",
          clueValues: [
            {
              value: "Ash",
              type: "text",
              style: {
                width: "calc(100% - 10px)",
              },
              subtext: "",
              id: "69d9ab48-577a-4169-a355-8f479fed8305",
            },
          ],
          dependsOn: [],
        },
        {
          id: "283be78f-e992-43c1-96c2-e71ccc001fdc",
          subtext: "",
          dependsOn: [],
          helperText:
            "Fictional entity in X-men series, closely related to Jean Grey.",
          solutionInfo: {
            solvedText: "",
            type: "text",
            possibleSolutions: [],
          },
          clueGroup: 3,
          clueValues: [
            {
              value: "Jean Grey",
              subtext: "",
              id: "40530bff-8699-418c-9b92-36c5c3cb756e",
              type: "text",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          style: {
            width: "calc(33% - 10px)",
          },
        },
      ],
      id: "dacc7700-7c36-45cf-a639-51963f4b2bf5",
    },
  ],
};

export default puzzle;
